<template>
  <div class="baiduQueue">
      <div class="box">
          <div class="b1">高级工程师信息</div>
          <div class="b2">
            <img :src="item.avatarUrl?item.avatarUrl:'/static/index/index16.png'" alt="">
            <div>
              <div class="b21">{{item.fullName}}</div>
              <div class="b22">工作时间：{{item.workTime}}</div>
              <div class="b22">服务区域：{{item.ranges}}</div>
              <div class="b22">服务设备：{{item.remark}}</div>
              <div class="b23" v-if="item.ids">
                <div v-for="(item2,index2) in item.ids.split(',')" :key="index2">{{item2}}</div>
              </div>
            </div>
          </div>
          <div class="b3" @click="show">立即咨询</div>
      </div>
      <show ref="show"></show>
  </div>
</template>

<script>
import Cookie from "js-cookie";
export default {
  title: "课程列表",
  data() {
    return {
      item:{}
    };
  },
  computed: {},
  components: {},
  methods: {
    getData() {
      this.$axios.post('/get_engineer_detail',this.$qs.stringify({eid:this.$route.query.id}) ).then(res => {
					this.item=res.data.data

				})
    },
    show(){
      this.$refs.show.click()
    }
  },

  mounted() {
    this.getData();  
  },
};
</script>  
<style lang="scss" scoped>
.baiduQueue{
  width: 100%;
  height: 100%;
  // overflow-y: auto;
  background: #FFFFFF;
  display: flex;
  flex-direction: column;
  padding-top: 30px;
  .box{
    width: 1200px;
    margin: 0  auto;
    height: 504px;
    background: #FFFFFF;
    border: 1px solid rgba(204, 204, 204, 0.5);
    position: relative;
    .b1{
      width: calc(100% - 32px);
      height: 60px;
      background: #F3F3F3;
      font-size: 24px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: #999999;
      padding-left: 32px;
      line-height: 60px;
    }
    .b2{
      width: 100%;
      height: 403px;
      display: flex;
      align-items: center;
      padding-bottom: 40px;
      img{
        width: 290px;
        height: 290px;
        margin-left: 30px;
        margin-right: 90px;
      }
      &>div{
        width: calc(100% - 441px);
        .b21{
          font-size: 30px;
          font-family: SourceHanSansCN-Bold, SourceHanSansCN;
          font-weight: bold;
          color: #333333;
          margin-bottom: 40px;
        }
        .b22{
          font-size: 24px;
          font-family: SourceHanSansCN-Regular, SourceHanSansCN;
          font-weight: 400;
          color: #333333;
        }
        .b23{
          display: flex;
          flex-wrap: wrap;
          margin-top: 30px;
          div{
            height: 32px;
            padding: 0 10px;
            border-radius: 6px;
            border: 1px solid #0457AD;
            line-height: 32px;
            font-size: 20px;
            font-family: SourceHanSansCN-Regular, SourceHanSansCN;
            font-weight: 400;
            color: #0457AD;
            margin-right: 10px;
            margin-bottom: 10px;
          }

        }

      }
    }
    .b3{
      width: 140px;
height: 38px;
background: #198AFA;
border-radius: 2px;
text-align: center;
line-height: 38px;
font-size: 16px;
font-family: SourceHanSansCN-Medium, SourceHanSansCN;
font-weight: 500;
color: #FFFFFF;
position: absolute;
right: 72px;
top: 130px;
cursor: pointer;
    }
  }
}
</style>  


// WEBPACK FOOTER //
// src/pages/engineerDetail/index.vue